import { isEmpty } from "lodash";

/**
 * Sorts the featured projects as per the following order
 * 1. Ather
 * 2. Atomberg
 * 3. Hindware
 * 4. Lenskart
 * 5. Ecom
 * @param {Array} featuredProjects
 * @returns {Array} The sorted array of the featured projects
 */
export const sortFeaturedProjects = (featuredProjects) => {
  const projectIds = [
    55, //1. Ather
    80, //2. Atomberg
    120, //3. Hindware
    81, //4. Lenskart
    107, //5. Ecom
  ];
  let tempProjects = [];
  projectIds.forEach((id, index) => {
    let n = featuredProjects.filter((project) => {
      return project?.id === id;
    });
    if (n.length > 0) {
      tempProjects.push(n[0]);
    }
  });

  tempProjects = [
    ...tempProjects?.sort(
      (a, b) => projectIds.indexOf(a) - projectIds.indexOf(b)
    ),
    ...featuredProjects?.filter(
      (i) => !tempProjects?.some((j) => j?.id === i?.id)
    ),
  ];

  return tempProjects;
};

/**
 * Sorts the testimonials as per the required order
 * 1. Sartorius
 * 2. Atomberg
 * 3. Ather
 * @param {Array} testimonials
 * @returns {Array} The sorted array of the testimonials
 */
export const sortTestimonials = (testimonials) => {
  if (isEmpty(testimonials)) {
    return [];
  }
  const testimonialIds = [
    10, //1. Sartorius
    11, //2. Atomberg
    12, //3. Ather
  ];
  let tempTestimonials = [];
  testimonialIds.forEach((id, index) => {
    let n = testimonials?.filter((testimonial) => {
      return testimonial?.id === id;
    });
    if (n?.length > 0) {
      tempTestimonials.push(n[0]);
    }
  });

  tempTestimonials = [
    ...tempTestimonials?.sort(
      (a, b) => testimonialIds.indexOf(a) - testimonialIds.indexOf(b)
    ),
    ...testimonials?.filter(
      (i) => !tempTestimonials?.some((j) => j?.id === i?.id)
    ),
  ];

  return tempTestimonials;
};

/**
 * Returns the first letter of the first 2 words from the given string to form an initials string.
 * @param {String} string string to manipulate from
 * @returns The capitalized initials
 */
export const renderInitials = (string) => {
  let initials = "";
  const parts = string?.split(" ");
  initials = parts[0][0] + parts[1][0];

  return initials?.toString()?.toUpperCase();
};
